import { ArticlesList } from '../../components';
import { withLayout } from '../../Layout/Layout';
import Head from 'next/head';
import React from 'react';

function News() {
  return (
    <>
      <Head>
        <meta
          name="description"
          content={
            'Get the latest updates on travel destinations worldwide with First-Class.com. Explore new hotspots, cultural insights, and travel tips'
          }
        />
        <title>Destination News: Stay Updated on Travel Destinations</title>
      </Head>
      <ArticlesList subtype="News" type="Destinations" />
    </>
  );
}

export default withLayout(News, true);
